module.exports = __webpack_public_path__ + "img/homepageIcon.1e2e5f7d.png";